<template>
  <div id="positions-filters">
    <div class="d-flex justify-space-between align-center">
      <div class="positions-filters-header">
        <v-btn
          class="elevation-0 button-show-filters mr-2 px-2"
          :color="
            !filtersCleaned
              ? $vuetify.theme.dark
                ? 'dark_backgroundLighterBlack'
                : 'softBackgroundGrey'
              : $vuetify.theme.dark
              ? 'dark_backgroundDarkBlue'
              : 'softPrimary'
          "
          small
          @click="toggleFilters"
        >
          <v-icon size="18">mdi-filter-outline</v-icon>
          <span v-if="!mdAndDown" class="mx-1">
            {{ $t('views.common.positionsFilters.showFilters') }}
          </span>
          <span v-if="filtersCleaned" class="ml-1">
            <b>({{ filtersCleaned }})</b>
          </span>
          <v-icon class="ml-0 mr-0" size="22">
            {{ showFilters ? 'mdi-menu-up' : 'mdi-menu-down' }}
          </v-icon>
        </v-btn>

        <template v-if="!mdAndDown">
          <v-chip-group v-model="myPositionType" active-class="primary" mandatory column>
            <v-chip
              v-for="positionTypeElem in positionTypes"
              :key="positionTypeElem.value"
              :value="positionTypeElem.value"
              outlined
            >
              {{ positionTypeElem.text }}
            </v-chip>
          </v-chip-group>
        </template>
        <template v-else>
          <v-select
            v-model="myPositionType"
            :items="positionTypes"
            dense
            hide-details
            class="position-filters-auto-complete pl-3 mb-0 pb-0"
          />
        </template>
      </div>

      <div>
        <slot name="buttons"></slot>
      </div>
    </div>

    <div v-if="showFilters">
      <v-row class="filters-row">
        <v-col cols="12" md="2" class="mt-0 pt-0">
          <v-autocomplete
            v-model="filters.ticker"
            :items="tickers"
            :label="$t('views.common.positionsFilters.filter.position')"
            multiple
            small-chips
            deletable-chips
            clearable
            hide-details
            class="position-filters-auto-complete"
          ></v-autocomplete>
        </v-col>
        <!-- <v-col v-if="type === 'position'" cols="12" md="2" class="mt-0 pt-0">
          <v-autocomplete
            v-model="filters['brokers.broker']"
            :items="brokers"
            :label="$t('views.common.positionsFilters.filter.broker')"
            multiple
            small-chips
            deletable-chips
            clearable
            hide-details
            class="position-filters-auto-complete"
          ></v-autocomplete>
        </v-col> -->
        <v-col cols="12" md="2" class="mt-0 pt-0">
          <v-autocomplete
            v-model="filters.country"
            :items="countries"
            :label="$t('views.common.positionsFilters.filter.country')"
            multiple
            small-chips
            deletable-chips
            clearable
            hide-details
            class="position-filters-auto-complete"
          ></v-autocomplete>
        </v-col>
        <v-col cols="12" md="2" class="mt-0 pt-0">
          <v-autocomplete
            v-model="filters.manager"
            :items="managers"
            :label="$t('views.common.positionsFilters.filter.manager')"
            multiple
            small-chips
            deletable-chips
            clearable
            hide-details
            class="position-filters-auto-complete"
          ></v-autocomplete>
        </v-col>
        <v-col cols="12" md="2" class="mt-0 pt-0">
          <v-autocomplete
            v-model="filters.sector"
            :items="sectors"
            :label="$t('views.common.positionsFilters.filter.sector')"
            multiple
            small-chips
            deletable-chips
            clearable
            hide-details
            class="position-filters-auto-complete"
          ></v-autocomplete>
        </v-col>
        <v-col cols="12" md="2" class="mt-0 pt-0">
          <TagBox
            ref="tagBox"
            v-model="filters.tags"
            :group="type"
            :label="$t('views.common.positionsFilters.filter.tags')"
            hideDetails
          />
        </v-col>
        <v-col cols="12" md="2" class="mt-0 pt-2">
          <v-btn
            class="elevation-0 button-show-filters mr-3"
            :class="{ 'black--text': !$vuetify.theme.dark, 'white--text': $vuetify.theme.dark }"
            small
            :color="$vuetify.theme.dark ? 'dark_backgroundLighterBlack' : 'softBackgroundGrey'"
            @click="clearFilters"
          >
            <span>
              {{ $t('views.common.positionsFilters.clearFilters') }}
            </span>
            <v-icon class="ml-2" size="20">
              mdi-filter-remove-outline
            </v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { pickBy } from 'lodash'
import { getPositionsLean, getWatchesLean } from '@/lib/api.js'
import { getPositionTypes, getPositionText } from '@/lib/positions/positions.js'
import TagBox from '@/views/components/common/TagBox'

export default {
  components: { TagBox },
  props: {
    type: {
      type: String,
      default: 'position',
    },
    positionType: {
      type: String,
      default: 'all',
    },
    showZeroPositions: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    filters: {},
    tickers: null,
    // brokers: null,
    countries: null,
    managers: null,
    sectors: null,
    tags: null,
    showFilters: false,
    myPositionType: null,
    positionTypes: [],
  }),
  computed: {
    ...mapGetters(['isAdminOrTesterRoleUser']),
    mdAndDown() {
      return this.$vuetify.breakpoint.mdAndDown
    },
    filtersCleaned() {
      return Object.keys(this.filters).length
    },
  },
  watch: {
    filters: {
      handler() {
        if (!Object.keys(this.filters).length) return
        const filterPositions = pickBy(this.filters, (filter) => filter.length) // delete empty filters
        filterPositions.tags = { $in: filterPositions.tags }
        this.$emit('filterPositions', filterPositions)
      },
      deep: true,
      immediate: true,
    },
    positionType: {
      handler() {
        this.myPositionType = this.positionType
      },
      immediate: true,
    },
    myPositionType() {
      this.$emit('update:positionType', this.myPositionType)
    },
    async showZeroPositions() {
      await this.updateFilters()
    },
  },
  methods: {
    setPositionTypes(positions) {
      const userPositionsTypes = [...new Set(positions.map((elem) => elem.type))]

      let typesToFilter = ['all']
      if (this.type === 'position') typesToFilter.push('allNeCash')

      const userPositionTypes = getPositionTypes({
        model: this.type,
        filterToHide: ['cash'],
      }).filter((positionType) => {
        return userPositionsTypes.indexOf(positionType) > -1
      })
      typesToFilter = [...typesToFilter, ...userPositionTypes]

      if (!this.hideCashPositionType) typesToFilter.push('cash') // cash the last one

      this.positionTypes = typesToFilter.map((positionType) => {
        return {
          text: this.$t(`common.positionTypes.${positionType}`),
          value: positionType,
        }
      })
    },
    async updateFilters() {
      const result =
        this.type === 'position'
          ? await getPositionsLean({
              filter: {
                positionNumber: this.showZeroPositions ? undefined : { $ne: 0 },
              },
            })
          : await getWatchesLean()
      const positions = result.data
      this.setPositionTypes(positions)
      const tickers = []
      // const brokers = []
      const countries = []
      const managers = []
      const sectors = []
      positions.forEach((position) => {
        // if (position.brokers) {
        //   for (const broker of position.brokers) {
        //     if (broker.broker) {
        //       brokers.push({
        //         text: broker.broker.name,
        //         value: broker.broker._id,
        //       })
        //     }
        //   }
        // }
        if (position.ticker)
          tickers.push({
            text: getPositionText(position),
            value: position.ticker,
          })
        if (position.country)
          countries.push({
            text: this.$te(`common.countries.${position.country}`)
              ? this.$t(`common.countries.${position.country}`)
              : position.country,
            value: position.country,
          })
        if (position.manager && managers.indexOf(position.manager) === -1)
          managers.push(position.manager)
        if (position.sector && sectors.indexOf(position.sector) === -1)
          sectors.push(position.sector)
      })
      this.tickers = tickers
      // this.brokers = brokers
      this.countries = countries
      this.managers = managers
      this.sectors = sectors

      if (this.$refs.tagBox) this.$refs.tagBox.updateTags()
    },
    clearFilters() {
      // si cambia esto revisar computed filtersCleaned

      this.filters = {}
      this.myPositionType = 'all'
      this.$emit('filterPositions', this.filters)
    },
    async toggleFilters() {
      if (this.showFilters) {
        this.showFilters = false
      } else {
        this.showFilters = true
      }
    },
    filterByTag(tag) {
      if (!this.showFilters) this.toggleFilters()
      this.$set(this.filters, 'tags', [tag])
    },
  },
}
</script>

<style lang="scss">
.theme--dark {
  #positions-filters {
    .positions-filters-header {
      .button-show-filters {
        color: white;
      }
    }
  }
}

#positions-filters {
  width: 100%;
  .positions-filters-header {
    .button-show-filters {
      margin-top: 1px;
      color: #1f1f1f;
      // height: 33px;
    }
    display: flex;
    align-items: center;
  }

  .position-filters-auto-complete {
    .v-select__selections {
      margin-bottom: 6px !important; // igualar la altura de los autocomplete a los v-select
    }
  }

  .filters-row {
    align-items: flex-end;
  }
}
</style>
